export const getHasData = (lastData: number | null): boolean => {
  if (lastData === null) {
    return false;
  }

  const timeNow = new Date().getTime() / 1000;
  const lastActiveHoursAgo = (timeNow - lastData) / 3600;
  return lastActiveHoursAgo < 24;
};
